export default {
  hero: {
    title: 'Par Mums',
    subtitle: 'The Daeg International Trade - Jūsu Uzticamais Partneris',
  },
  intro: {
    title: 'Par The Daeg International Trade',
    description1: 'The Daeg International Trade ir vadošais uzņēmums importa-eksporta un starptautisko investīciju konsultāciju jomā. Ar vairāk nekā 5 gadu pieredzi, mēs esam palīdzējuši simtiem klientu gūt panākumus biznesa paplašināšanā un investīciju mērķu sasniegšanā.',
    description2: 'Mēs specializējamies visaptverošu risinājumu sniegšanā no Āzijas preču importa uz Eiropu, Latvijas uzturēšanās investīciju konsultācijām līdz Asian Alley veikalu ķēdes darbībai - Āzijas kultūras tilts ar Eiropas tirgu.',
  },
  values: {
    title: 'Pamatvērtības',
    subtitle: 'Vērtības, kas vada visas mūsu darbības',
    items: [
      {
        title: 'Godīgums',
        description: 'Mēs vienmēr liekam godīgumu un pārredzamību pirmajā vietā visos darījumos',
      },
      {
        title: 'Apņemšanās',
        description: 'Apņemšanās apkalpot un pavadīt klientus visā ceļojumā',
      },
      {
        title: 'Profesionalitāte',
        description: 'Profesionāls darba process ar pieredzējušu ekspertu komandu',
      },
      {
        title: 'Efektivitāte',
        description: 'Koncentrēšanās uz reāliem rezultātiem un ilgtspējīgu vērtību klientiem',
      },
    ],
  },
  asianAlley: {
    title: 'Asian Alley - Mūsu Lepnums',
    description: 'Asian Alley ir mūsu Āzijas veikalu ķēde Latvijā, kur mēs piedāvājam kvalitatīvus Āzijas produktus Eiropas kopienai. Tas nav tikai bizness, bet arī kultūras tilts un biznesa iespēju radītājs partneriem.',
    stats: [
      {
        value: '2',
        label: 'Filiāles',
      },
      {
        value: '€500K+',
        label: 'Apgrozījums/Gadā',
      },
      {
        value: 'Tūkstoši',
        label: 'Klienti',
      },
    ],
  },
  cta: {
    title: 'Gatavi Sākt?',
    description: 'Sazinieties ar mums jau šodien, lai saņemtu bezmaksas konsultāciju par importa-eksporta risinājumiem un Latvijas uzturēšanās investīcijām.',
    phone: 'Tālrunis',
    email: 'E-pasts',
    emailNote: 'Atbilde 24 stundu laikā',
    address: 'Adrese',
    addressValue: 'Rīga, Latvija',
    button: 'Sazināties Tagad',
  },
} as const;